import { render, staticRenderFns } from "./CampaignSettingsIntegrations.vue?vue&type=template&id=20b9cb8e&"
import script from "./CampaignSettingsIntegrations.vue?vue&type=script&lang=js&"
export * from "./CampaignSettingsIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports